import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import CurrriculumModules from "./CurrriculumModules";

export const resources = {
  name: StudentServicePath + MODULES + "/" + CURRICULUMS + "/:id",
  title: "Учебни планове - Модули",
  custom: <CurrriculumModules />,
  permission: permissions.canPreviewCurriculumModules,
};
